import { Card, CardContent, Grid, makeStyles, Typography } from '@material-ui/core'
import React from 'react'
import QRCode from 'react-qr-code';
import FondoCredencial from '../../../assets/Fondo_Credencial.png'
import LogoBlanco from '../../../assets/Logo_Blanco.png'
import { useDispatch } from 'react-redux';
import { finishSpinner, startSpinner } from '../../../actions/ui/spinner';
import html2canvas from 'html2canvas';
import jsPDF from 'jspdf';
import moment from 'moment';

const useStyles = makeStyles((theme) => ({
    root: {
        minHeight: '100%',
        marginTop: "1.5rem",
        marginBottom: "1rem"
    },
    title: {
        fontWeight: "bold"
    },
    card: {
        // marginTop: "1rem",
        marginBottom: "1rem",
        position: "relative",
        cursor:"pointer"
    },
    cardIn: {
        borderRadius: 15,
        backgroundImage: `url(${FondoCredencial})`,
        backgroundSize: "cover",
        backgroundRepeat: "no-repeat",
        padding: "0px",
        [theme.breakpoints.up('sm')]: {
            padding: '1rem',
        },
    },
    logoContainer: {
        textAlign: "left"
    },
    logoCard: {
        width: "50%"
    },
    titleCredencial: {
        fontWeight: "bold",
        color: "#fff",
        marginRight: 5
    },
    numberCredencial: {
        color: "#fff"
    },
    containerBody: {
        marginTop: "1rem"
    },
    centerTextBody: {
        display: "flex",
        alignItems: "center"
    },
    containerTextVencida: {
        backgroundColor: "rgba(255, 0, 0, 0.9)",
        position: "absolute",
        top: 1,
        right: 15
    },
    textVencida: {
        textAlign: "right",
        color: "#fff",
        fontWeight: "bold",
        fontSize: 11,
        padding: 2,
    },
}));

const CardCredencial = ({ credencial}) => {
    const classes = useStyles()
    const dispatch = useDispatch()

    const convertHtmlImage = (idContainer) => {
        dispatch(startSpinner())
        let container = document.getElementById(idContainer);
        //Esta libreria tarda menos, pero no toma todos los estilos
        // htmlToImage.toPng(container, {width:500, height:500})
        //     .then(function (dataUrl) {
        //         download(dataUrl, `${idContainer}.png`);
        //         dispatch(finishSpinner())
        //     }).catch(e => {
        //         dispatch(finishSpinner())
        //     })
        html2canvas(container, {width:500, height:500}).then(function(canvas) {
            const imgData = canvas.toDataURL('image/png');
            const pdf = new jsPDF();
            // pdf.text(moment(new Date()).format("DD/MM/YYYY").toString())
            pdf.text(moment(new Date()).format("DD/MM/YYYY hh:mm"), 90, 15)
            pdf.addImage(imgData, 'png', 50, 20);
            // pdf.output('dataurlnewwindow');
            pdf.save(`${idContainer}.pdf`);
            dispatch(finishSpinner())
        }).catch(e=>{
            dispatch(finishSpinner())
        })
    }

    return (
        <Grid container key={credencial.numero}>

            <Grid item xs={null} sm={2} md={3} />
            <Grid item xs={12} sm={8} md={6} className={classes.card}  id={`credencial-${credencial.numero}`}>
                {
                    !credencial.vigente &&
                    <div className={classes.containerTextVencida}><Typography className={classes.textVencida}>COBERTURA VENCIDA</Typography></div>
                }
                <Card variant="outlined" className={classes.cardIn} onClick={() => convertHtmlImage(`credencial-${credencial.numero}`)}>
                    {/* <CardActionArea > */}
                        <CardContent>
                            <div className={classes.logoContainer}>
                                <img alt="Logo Blanco" src={LogoBlanco} className={classes.logoCard} />
                            </div>
                            <Grid container className={classes.containerBody}>
                                <Grid item xs={6} className={classes.centerTextBody}>
                                    <div>
                                        <Typography className={classes.titleCredencial} >{credencial.apellidoYNombre}</Typography>
                                        <Typography className={classes.numberCredencial}>{credencial.numero}</Typography>
                                    </div>
                                </Grid>
                                <Grid item xs={6} style={{ textAlign: "right" }}>
                                    <QRCode
                                        value={`${process.env.REACT_APP_URL_BASE}/afiliado/credenciales/informacion-afiliado/${credencial.idAfiliado}`}
                                        size={125}
                                    />
                                </Grid>
                            </Grid>
                        </CardContent>
                    {/* </CardActionArea> */}
                </Card>
            </Grid>
            <Grid item xs={null} sm={2} md={3} />
        </Grid>
    )
}

export default CardCredencial
